import Navbar from './components/Navbar';
import Section01Hero from './sections/Section01Hero';
import Section02Background from './sections/Section02Background';
import Section03Product from './sections/Section03Product';
import Section04Demo from './sections/Section04Demo';
import Section05Market from './sections/Section05Market';
import Section06Business from './sections/Section06Business';
import Section07Finance from './sections/Section07Finance';
import Section08Team from './sections/Section08Team';
import Section09Roadmap from './sections/Section09Roadmap';
import Section10Footer from './sections/Section10Footer';

// 单页面应用主入口：组合10个全屏锚点区块与固定导航栏
export default function App() {
  return (
    <div className="min-h-screen bg-deepBlue text-white overflow-x-hidden">
      <Navbar />
      <main>
        <Section01Hero />
        <Section02Background />
        <Section03Product />
        <Section04Demo />
        <Section05Market />
        <Section06Business />
        <Section07Finance />
        <Section08Team />
        <Section09Roadmap />
        <Section10Footer />
      </main>
    </div>
  );
}
